import React from "react";
import PropTypes from "prop-types";

import { Grid, Typography } from "@mui/material";

import { CommonModal, PrimaryButton, SecondaryButton } from "../index";

import { trakrefFontFamily } from "../../../utils";
import { Grey1, Grey3 } from "../../../color_utils"

const ShutdownWarningModal = ({
  open,
  title,
  description,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  onCancel,
  renderCloseIcon,
}) => (
  <CommonModal open={open} close={onCancel} renderCloseIcon={renderCloseIcon}>
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ marginTop: '2%' }}>
        <Typography
          variant="h5"
          sx={{
            "&.MuiTypography-root": {
              fontFamily: trakrefFontFamily,
              color: Grey1,
            },
          }}
          align="center"
        >
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          sx={{
            "&.MuiTypography-root": {
              fontFamily: trakrefFontFamily,
              fontSize: 14,
              color: Grey3,
            },
          }}
          align="center"
        >
          {description}
        </Typography>
      </Grid>
      <Grid item xs={12} align="center">
        <PrimaryButton
          useLargeButton
          buttonText={confirmButtonText}
          onClick={onConfirm}
          width={75}
        />
      </Grid>
      <Grid item xs={12} align="center">
        <SecondaryButton
          useLargeButton
          buttonText={cancelButtonText}
          onClick={onCancel}
          width={75}
        />
      </Grid>
    </Grid>
  </CommonModal>
);

ShutdownWarningModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  renderCloseIcon: PropTypes.bool,
};

ShutdownWarningModal.defaultProps = {
  open: false,
  confirmButtonText: "Complete",
  cancelButtonText: "Edit Date",
  renderCloseIcon: true
};

export default ShutdownWarningModal;
